import React from 'react';
import Layout from '../../components/layout/Layout';
import { Typography } from '@mui/material';

function Home() {
  return (
    <Layout>
      <Typography variant="h4">Procedure App</Typography>
    </Layout>
  );
}

export default Home;
